import CreativeCrood from '../images/creativeCrood.png';
import ZeroDoc from '../images/zerodoc.png';
import ZeroDoc2 from '../images/zerodoc2.png';

const projects = [
  {
    id: 1,
    title: "ZeroDOCS",
    description: "Ready to make EPDs work for your brand? Let’s get started! Reach out to learn how an EPD can elevate your brand and secure your place in sustainable building projects.",
    image: ZeroDoc,
    detailImages: [
        ZeroDoc,
        ZeroDoc2,
    ],
    liveLink: "https://zerodocs.com/",
    localLink: "",
    githubLink: "",
    technologies: ["Bootstrap", "HTML", "CSS", "PHP"]
  },

];

export default projects;
